<template>
    <main class="J-container-visual" :class="{'show':open}">
        <div class="J-container-back" @click="isOpen()">

        </div>
        <div class="J-container-img">
            <img :src="url" alt="">
        </div>
        <button class="J-close" @click="isOpen()">
            <i class="fas fa-times"></i>   
        </button> 
    </main>
</template>
<script>
export default {
    data:()=>({
       open:false,
    }),
    props:{
        url:'',
    },
    methods:{
        isOpen(){
            this.open=!this.open
        }
    }

}
</script>